export default class DocumentType {
  public constructor(public readonly value: string, public readonly displayName: string) {}

  public toString = (): string => {
    return this.value;
  };
}
